import React from "react";

type PropsType = {
  style?: React.CSSProperties;
  size?: number;
};

const MikataWhiteLogo = ({ size = 178, style = {} }: PropsType) => {
  return (
    <svg
      width={size}
      height={(size / 178) * 181}
      style={style}
      viewBox="0 0 178 181"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_275_13192)">
        <g filter="url(#filter0_d_275_13192)">
          <circle cx="88.7782" cy="88.7782" r="78.7782" fill="white" />
        </g>
        <path
          d="M135.106 121.767C138.526 121.767 141.298 118.974 141.298 115.528C141.298 112.082 138.526 109.289 135.106 109.289C131.686 109.289 128.914 112.082 128.914 115.528C128.914 118.974 131.686 121.767 135.106 121.767Z"
          fill="#FF878F"
        />
        <path
          d="M102.522 61.4529C96.8738 61.4508 91.4322 63.5987 87.2839 67.4677C86.9312 67.7979 86.4679 67.9813 85.9869 67.9813C85.5058 67.9813 85.0425 67.7979 84.6898 67.4677C80.5415 63.5987 75.0999 61.4508 69.4513 61.4529C56.9209 61.4529 46.7646 71.8301 46.7646 84.6305V115.335C46.7646 118.742 49.3566 121.643 52.6895 121.765C53.521 121.79 54.349 121.646 55.1242 121.342C55.8993 121.037 56.6055 120.577 57.2007 119.991C57.7958 119.404 58.2677 118.703 58.5879 117.928C58.9082 117.153 59.0703 116.321 59.0646 115.482V84.9049C59.0646 79.0408 63.7153 74.293 69.4409 74.293C75.1769 74.293 79.8275 79.045 79.8275 84.9049V115.335C79.8275 118.742 82.4195 121.643 85.7523 121.765C86.5837 121.79 87.4117 121.646 88.1867 121.342C88.9617 121.037 89.6679 120.577 90.2628 119.991C90.8578 119.404 91.3295 118.703 91.6495 117.928C91.9695 117.153 92.1314 116.321 92.1254 115.482V84.9049C92.1254 79.0408 96.7761 74.293 102.512 74.293C108.248 74.293 112.899 79.045 112.899 84.9049V115.335C112.899 118.742 115.493 121.643 118.826 121.765C119.657 121.79 120.485 121.646 121.26 121.342C122.035 121.037 122.741 120.577 123.336 119.991C123.931 119.404 124.403 118.703 124.723 117.928C125.043 117.153 125.205 116.321 125.199 115.482V84.6305C125.209 71.8301 115.053 61.4529 102.522 61.4529Z"
          fill="#003125"
        />
        <path
          d="M52.9568 61.8688C56.3767 61.8688 59.149 59.0753 59.149 55.6293C59.149 52.1834 56.3767 49.3899 52.9568 49.3899C49.537 49.3899 46.7646 52.1834 46.7646 55.6293C46.7646 59.0753 49.537 61.8688 52.9568 61.8688Z"
          fill="#00D598"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_275_13192"
          x="-6"
          y="-5"
          width="189.557"
          height="189.556"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0779338 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_275_13192"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_275_13192"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_275_13192">
          <rect width="178" height="181" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MikataWhiteLogo;
